import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {ActivatedRoute} from '@angular/router';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from "angular2-notifications";
import {BarChartComponent} from '../zoomView/bar-chart/bar-chart.component';
import {ModalService} from "../../../services/modalService/modal.service";
import {UtilsService} from '../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-least-used-features',
  templateUrl: './least-used-features.component.html',
  styleUrls: ['./least-used-features.component.css', '../myreports.component.css']
})
export class LeastUsedFeaturesComponent implements OnInit {

  ruid: string;
  public barChartData = [];
  public options = {
    height: 400,
    titlePosition: 'out',
    chartArea: {height: '100%', width: '60%', left: 150},
    vAxis: {title: this.translate.instant('reports.feature')},
    hAxes: {
      0: {title: this.translate.instant('reports.totalUsage'), formatter: 'minsToHours'},
      1: {title: this.translate.instant('reports.noSession')}
    },
    series: {
      0: {targetAxisIndex: 0},
      1: {targetAxisIndex: 1},
      2: {targetAxisIndex: 1}
    },
    colors: ['#ffeb3b', '#9c27b0'],
    showAnnotations: true
  };
  isLoggedIn: boolean = false;
  isLicense: string;
  leastFeatures: any = {};

  constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private utilService: UtilsService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
              this.isLoggedIn = currentUser.isLoggedIn;
              if (this.isLoggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    }
                  }, (error) => {
                      this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                  });
              }
            });
        }
      }
    });
  }

  reportsData() {
    this.apiService.getChartData(this.ruid, 'LEAST_FEATURE_USAGE')
      .subscribe((res) => {
        this.leastFeatures = res;
        res.data[0] = this.backendTranslate.translateCollection(res.data[0]);
        if (res.data[1]) {
          this.barChartData = this.leastFeatures.data;
          this.utilService.updateChartAreaFromData(this.barChartData, this.options);
        }
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.featureFail')));
      });
  }

  zoomView() {
      if (this.barChartData.length === 0) {
          return;
      }
    this.modalService.open(BarChartComponent, {
      title: this.translate.instant('reports.leastUsedC.top10'),
      data: {
        chartData: this.leastFeatures,
        isLicense: this.isLicense,
        options: this.options
      }
    }).subscribe(model => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/least-used-features/least-used-features.component.ts